'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useQuery } from '@repo/tanstack/query';
import { Field, FieldContent, FieldDescription, FieldError, FieldLabel, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, Spinner } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormOrganisationSelect = t0 => {
  const $ = _c(51);
  const {
    className,
    "data-testid": dataTestId,
    description,
    disabled,
    isPending: t1,
    label,
    placeholder: t2
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "Select organisation" : t2;
  const field = useFieldContext();
  const api = useApi();
  let t3;
  if ($[0] !== api.organisations.list) {
    t3 = api.organisations.list.queryOptions();
    $[0] = api.organisations.list;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    data: t4,
    error,
    isPending: isLoading
  } = useQuery(t3);
  let t5;
  if ($[2] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const organisations = t5;
  let t6;
  if ($[4] !== field.name || $[5] !== label) {
    t6 = label && <FieldLabel htmlFor={field.name}>{label}</FieldLabel>;
    $[4] = field.name;
    $[5] = label;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = disabled || isPending || isLoading;
  let t8;
  if ($[7] !== organisations) {
    t8 = [{
      items: organisations,
      value: "Organisations"
    }];
    $[7] = organisations;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== field) {
    t9 = value => field.handleChange(Number(value));
    $[9] = field;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== field.state.value) {
    t10 = field.state.value?.toString() ?? "";
    $[11] = field.state.value;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== className) {
    t11 = cn("flex w-full justify-between gap-2", className);
    $[13] = className;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = dataTestId ?? "form-organisation-select-trigger";
  let t13;
  if ($[15] !== organisations || $[16] !== placeholder) {
    t13 = <SelectValue data-sentry-element="SelectValue" data-sentry-source-file="form-organisation-select.tsx">{value_0 => organisations.find(org => org.id.toString() === value_0)?.name ?? placeholder}</SelectValue>;
    $[15] = organisations;
    $[16] = placeholder;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== isLoading || $[19] !== isPending) {
    t14 = (isPending || isLoading) && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[18] = isLoading;
    $[19] = isPending;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== field.name || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t14) {
    t15 = <SelectTrigger className={t11} data-testid={t12} id={field.name} data-sentry-element="SelectTrigger" data-sentry-source-file="form-organisation-select.tsx">{t13}{t14}</SelectTrigger>;
    $[21] = field.name;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SelectLabel data-sentry-element="SelectLabel" data-sentry-source-file="form-organisation-select.tsx">Organisations</SelectLabel>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== organisations) {
    t17 = organisations.map(_temp);
    $[28] = organisations;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t17) {
    t18 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="form-organisation-select.tsx"><SelectGroup data-sentry-element="SelectGroup" data-sentry-source-file="form-organisation-select.tsx">{t16}{t17}</SelectGroup></SelectContent>;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t10 || $[33] !== t15 || $[34] !== t18 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
    t19 = <FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-organisation-select.tsx"><Select disabled={t7} items={t8} onValueChange={t9} value={t10} data-sentry-element="Select" data-sentry-source-file="form-organisation-select.tsx">{t15}{t18}</Select></FieldContent>;
    $[32] = t10;
    $[33] = t15;
    $[34] = t18;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== description) {
    t20 = description && <FieldDescription>{description}</FieldDescription>;
    $[39] = description;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== error) {
    t21 = error && <FieldDescription>Unable to load organisations</FieldDescription>;
    $[41] = error;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== field.state.meta.errors) {
    t22 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-organisation-select.tsx" />;
    $[43] = field.state.meta.errors;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t19 || $[46] !== t20 || $[47] !== t21 || $[48] !== t22 || $[49] !== t6) {
    t23 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="FormOrganisationSelect" data-sentry-source-file="form-organisation-select.tsx">{t6}{t19}{t20}{t21}{t22}</Field>;
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
    $[48] = t22;
    $[49] = t6;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
};
function _temp(organisation) {
  return <SelectItem data-testid={`form-organisation-select-option-${organisation.id}`} key={organisation.id} value={organisation.id.toString()}>{organisation.name}</SelectItem>;
}